export const QD_CLOUD_SESSION_STORAGE_KEY = 'qodana-cloud-session-storage.v1.'

export enum SessionStorageUnits {
	projectSetupSelectedGithubAccount = 'project-setup-selected-github-account.v1',
	authRedirectTimestamp = 'auth-redirect-timestamp.v1',
	authRedirectAttempted = 'auth-redirect-attempted.v1',
	userAttribution = 'user-attribution.v1',
}
